import { useState, useContext, useEffect } from "react";

import CustomAccordion from "../accordion/CustomAccordion.jsx";
import Canvas from "../Canvas.jsx";
// import { useLocation } from "react-router-dom";
// icons
import { GiReceiveMoney } from "react-icons/gi";
import {
  ManagerIcon,
  UsersIcon,
  HandIcon,
  ShoppingIcon,
  BasketIcon,
  UserListIcon,
  ListIcon1,
  DepotIcon,
  CircleIcon,
  CircleIcon2,
  CloseIcon,
  GridIcon,
  ClipBoardIcon,
  PlusIcon,
} from "../Icons.tsx";

import ColorSchema from "../Color/index.tsx";
import { NavLink, useLocation } from "react-router-dom";

import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";

import "./layout.scss";
export default function SideBar({
  type,
  showCanvas,
  setShowCanvas,
  selectedItem,
  setSelectedItem,
}) {
  // const location = useLocation();
  // console.log("param", location.pathname);

  const [sidebarOpen, setSidebarOpen] = useState("fixed");
  const [sidebarCanvas, setSidebarCanvas] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(location.pathname);
  return (
    <div className="" style={{ width: sidebarOpen == "fixed" && 300 }}>
      <div className="px-3">
        <div className="d-flex justify-content-between align-items-center mt-3 ">
          {sidebarOpen != "mini" && <h4>پنل ادمین</h4>}
          {type == "offcanvas" ? (
            <button
              className="btn btnOnFocus"
              onClick={() => {
                setShowCanvas(false);
              }}
            >
              <CloseIcon />
            </button>
          ) : (
            <div>
              {sidebarOpen == "fixed" && (
                <button
                  className="btn"
                  onClick={() => {
                    setSidebarOpen("mini");
                  }}
                >
                  <CircleIcon color={ColorSchema.blue_custom} />{" "}
                </button>
              )}

              {sidebarOpen == "mini" && (
                // <div className="text-center px-3 mt-3">
                <div
                  style={{ width: 70 }}
                  className="px-4"
                  onMouseEnter={() => {
                    setSidebarCanvas(true);
                  }}
                  onMouseLeave={() => {
                    setSidebarCanvas(false);
                  }}
                >
                  <ManagerIcon />
                  <Canvas
                    show={sidebarCanvas}
                    setShow={setSidebarCanvas}
                    placement="start"
                    width={300}
                    bgColor="#f3f4f4"
                    backdrop={false}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>پنل ادمین</h4>
                      <button
                        className="btn"
                        onClick={() => {
                          setSidebarOpen("fixed");
                          setSidebarCanvas(false);
                        }}
                      >
                        <CircleIcon2 color={ColorSchema.blue_custom} />{" "}
                      </button>
                    </div>
                    <SideBarData
                      showCanvas={showCanvas}
                      setShowCanvas={setShowCanvas}
                      // sidebarOpen={sidebarOpen}
                      setSidebarOpen={setSidebarOpen}
                      setSidebarCanvas={setSidebarCanvas}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      sidebarOpen="dynamic"
                    />
                  </Canvas>
                </div>
                // </div>
              )}
            </div>
          )}
        </div>
        <SideBarData
          showCanvas={showCanvas}
          setShowCanvas={setShowCanvas}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          setSidebarCanvas={setSidebarCanvas}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </div>
    </div>
  );
}

function SideBarData({
  sidebarOpen,
  setSidebarOpen,
  showCanvas,
  setShowCanvas,
  setSidebarCanvas,
  selectedItem,
  setSelectedItem,
}) {
  const { userInfo } = useContext(AuthenticationContext);

  const { logout } = useContext(AuthenticationContext);
  useEffect(() => {}, [userInfo["userRoll"].length]);
  // const [sidebarCanvas, setSidebarCanvas] = useState(false);
  return (
    <div className="d-flex flex-column justify-centent-center">
      <div>
        <div
          className="px-3  mt-3"
          style={{
            backgroundColor: selectedItem == "/" && "#d7dce3",
            borderRadius: 10,
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedItem("/");
            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <NavLink
            to="/"
            className="text-decoration-none text-secondary d-block"
            style={{ height: "52px" }}
          >
            <div className="d-flex align-items-center py-3">
              <GridIcon width={20} height={20} />
              {sidebarOpen != "mini" && <h6 className="ms-3">داشبورد</h6>}
            </div>
          </NavLink>
        </div>
        {(userInfo.userRoll.includes(1) ||
          userInfo.userRoll.includes(2) ||
          userInfo.userRoll.includes(3)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/product-list" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/product-list");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/product-list"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <BasketIcon width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">لیست محصولات</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}
        {(userInfo.userRoll.includes(4) ||
          userInfo.userRoll.includes(5) ||
          userInfo.userRoll.includes(6) ||
          userInfo.userRoll.includes(7) ||
          userInfo.userRoll.includes(8) ||
          userInfo.userRoll.includes(9) ||
          userInfo.userRoll.includes(10)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/customer-list" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/customer-list");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/customer-list"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <UsersIcon width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">لیست مشتریان</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}
        {(userInfo.userRoll.includes(11) ||
          userInfo.userRoll.includes(12) ||
          userInfo.userRoll.includes(13) ||
          userInfo.userRoll.includes(14)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/clew-list" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/clew-list");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/clew-list"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <UserListIcon width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">لیست سرنخ ها</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}

        {(userInfo.userRoll.includes(15) ||
          userInfo.userRoll.includes(16) ||
          userInfo.userRoll.includes(17) ||
          userInfo.userRoll.includes(18) ||
          userInfo.userRoll.includes(19)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/orders" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/orders");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/orders"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <ShoppingIcon width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">لیست سفارشات</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}
        {(userInfo.userRoll.includes(20) ||
          userInfo.userRoll.includes(21) ||
          userInfo.userRoll.includes(22) ||
          userInfo.userRoll.includes(23) ||
          userInfo.userRoll.includes(24)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/campaign" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/campaign");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/campaign"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <ListIcon1 width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">لیست کمپین ها</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}
        {(userInfo.userRoll.includes(25) ||
          userInfo.userRoll.includes(26) ||
          userInfo.userRoll.includes(27) ||
          userInfo.userRoll.includes(28) ||
          userInfo.userRoll.includes(29) ||
          userInfo.userRoll.includes(30) ||
          userInfo.userRoll.includes(31) ||
          userInfo.userRoll.includes(32) ||
          userInfo.userRoll.includes(33) ||
          userInfo.userRoll.includes(34)) && (
          <div
            className="px-3"
            style={{
              backgroundColor:
                selectedItem == "/admin-panel/user-management" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/admin-panel/user-management");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/admin-panel/user-management"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <ManagerIcon width={20} height={20} />
                {sidebarOpen != "mini" && (
                  <h6 className="ms-3">مدیریت کاربران</h6>
                )}
              </div>
            </NavLink>
          </div>
        )}
        {userInfo.userRoll.includes(35) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/messages" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/messages");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/messages"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <HandIcon width={20} height={20} />
                {sidebarOpen != "mini" && <h6 className="ms-3">ارتباطات</h6>}
              </div>
            </NavLink>
          </div>
        )}
        {(userInfo.userRoll.includes(36) ||
          userInfo.userRoll.includes(37) ||
          userInfo.userRoll.includes(38) ||
          userInfo.userRoll.includes(39) ||
          userInfo.userRoll.includes(40) ||
          userInfo.userRoll.includes(41)) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/storage" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/storage");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink
              to="/storage"
              className="text-decoration-none text-secondary"
            >
              <div className="d-flex align-items-center py-3">
                <DepotIcon width={20} height={20} />
                {sidebarOpen != "mini" && <h6 className="ms-3">انبار</h6>}
              </div>
            </NavLink>
          </div>
        )}
        <div
          className="px-3"
          style={{
            backgroundColor:
              selectedItem == "/financial-management" && "#d7dce3",
            borderRadius: 10,
          }}
          onClick={() => {
            setSelectedItem("/financial-management");
            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <NavLink
            to="/financial-management"
            className="text-decoration-none text-secondary"
          >
            <div className="d-flex align-items-center py-3">
              <GiReceiveMoney width={20} height={20} />
              {sidebarOpen != "mini" && <h6 className="ms-3">امورمالی</h6>}
            </div>
          </NavLink>
        </div>

        <div
          className="px-3"
          style={{
            backgroundColor: selectedItem == "/clew-step" && "#d7dce3",
            borderRadius: 10,
          }}
          onClick={() => {
            setSelectedItem("/clew-step");
            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <NavLink
            to="/clew-step"
            className="text-decoration-none text-secondary"
          >
            <div className="d-flex align-items-center py-3">
              <ClipBoardIcon width={20} height={20} />
              {sidebarOpen != "mini" && <h6 className="ms-3">وظایف من</h6>}
            </div>
          </NavLink>
        </div>

        <div
          className="px-3"
          style={{
            backgroundColor: selectedItem == "/reg-performance" && "#d7dce3",
            borderRadius: 10,
          }}
          onClick={() => {
            setSelectedItem("/reg-performance");
            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <NavLink
            to="/reg-performance"
            className="text-decoration-none text-secondary"
          >
            <div className="d-flex align-items-center py-3">
              <PlusIcon width={20} height={20} />
              {sidebarOpen != "mini" && <h6 className="ms-3">ثبت عملکرد</h6>}
            </div>
          </NavLink>
        </div>

        <div
          className="px-3"
          style={{
            backgroundColor:
              selectedItem == "/personal-performance-report" && "#d7dce3",
            borderRadius: 10,
          }}
          onClick={() => {
            setSelectedItem("/personal-performance-report");
            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <NavLink
            to="/personal-performance-report"
            className="text-decoration-none text-secondary"
          >
            <div className="d-flex align-items-center py-3">
              <GridIcon width={20} height={20} />
              {sidebarOpen != "mini" && <h6 className="ms-3">مدیریت عملکرد</h6>}
            </div>
          </NavLink>
        </div>

        {userInfo.userRoll.includes(42) && (
          <div
            className="px-3"
            style={{
              backgroundColor: selectedItem == "/chat" && "#d7dce3",
              borderRadius: 10,
            }}
            onClick={() => {
              setSelectedItem("/chat");
              if (showCanvas == true) {
                setShowCanvas(false);
              }
            }}
            onMouseEnter={() => {
              sidebarOpen == "mini" && setSidebarCanvas(true);
            }}
            onMouseLeave={() => {
              sidebarOpen == "mini" && setSidebarCanvas(false);
            }}
          >
            <NavLink to="/chat" className="text-decoration-none text-secondary">
              <div className="d-flex align-items-center py-3">
                <GridIcon width={20} height={20} />
                {sidebarOpen != "mini" && <h6 className="ms-3">پیام رسان</h6>}
              </div>
            </NavLink>
          </div>
        )}

        <div
          className="py-3 px-3"
          style={{
            // backgroundColor: "#d7dce3",
            borderRadius: 10,
            cursor: "pointer",
          }}
          onClick={() => {
            logout();

            if (showCanvas == true) {
              setShowCanvas(false);
            }
          }}
          onMouseEnter={() => {
            sidebarOpen == "mini" && setSidebarCanvas(true);
          }}
          onMouseLeave={() => {
            sidebarOpen == "mini" && setSidebarCanvas(false);
          }}
        >
          <div className="d-flex align-items-center">
            <CloseIcon width={20} height={20} />
            {sidebarOpen != "mini" && <h6 className="ms-3">خروج</h6>}
          </div>
        </div>
      </div>
    </div>
  );
}
